import React from 'react';
import './AvailabilityBadge.css';

const AVAILABILITY_CONFIG = {
  shipped_abroad: { label: 'Shipped from Abroad', modifier: 'abroad' },
  available_locally: { label: 'Available Locally', modifier: 'local' },
  for_export: { label: 'For Export', modifier: 'export' },
};

/**
 * Renders a small badge for product availability type.
 * @param {string} availabilityType - One of: shipped_abroad, available_locally, for_export
 * @param {string} [size] - 'small' (cards) or 'large' (details page). Default: small
 */
const AvailabilityBadge = ({ availabilityType, size = 'small' }) => {
  if (!availabilityType) return null;
  const config = AVAILABILITY_CONFIG[availabilityType];
  if (!config) return null;

  return (
    <span className={`availability-badge availability-badge--${config.modifier} availability-badge--${size}`}>
      {config.label}
    </span>
  );
};

export default AvailabilityBadge;
export { AVAILABILITY_CONFIG };
